import { render, staticRenderFns } from "./manageOrders.vue?vue&type=template&id=e6492946&"
import script from "./manageOrders.vue?vue&type=script&lang=js&"
export * from "./manageOrders.vue?vue&type=script&lang=js&"
import style0 from "./manageOrders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./manageOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports